import LoyaltyTier from '@components/loyaltyTier/LoyaltyTier'
import Page from '@components/Page/Page'
import { TableFilters } from '@components/TableFilters'
import { User } from '@components/user/User'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { User as UserModel } from '@models/User'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { getUsers, selectUsers, setUserQuery } from '@store/UserReducer'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { numberFormat } from '@utils/currencyFormatter'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { Input, Space } from 'antd'

const UsersPage = () => {
  const dispatch = useAppDispatch()
  const users = useAppSelector(selectUsers())
  const { query, isLoading } = useAppSelector((state) => state.user)

  const columns: TableColumnsType<UserModel> = [
    {
      title: 'Name',
      width: 300,
      fixed: 'left',
      render: (record: UserModel) => (
        <User.Avatar model={record} nameMaxWidth={200} />
      ),
    },
    {
      title: 'Email',
      render: (record: UserModel) => record.email,
    },
    {
      title: 'Phone',
      render: (record: UserModel) => record.phone,
    },
    {
      title: 'Loyalty Tiers',
      width: 300,
      render: (record: UserModel) => (
        <Space wrap>
          {record.loyaltyTiers?.map((id) => (
            <LoyaltyTier.Tag key={id} id={id} />
          ))}
        </Space>
      ),
    },
  ]

  const fetchUsers = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
      search: params.search,
    }

    dispatch(setUserQuery(newQuery))
    dispatch(getUsers(newQuery))
  }

  const { handleTableChange, handleFiltersChange, params } =
    useTableUrlSync<UserModel>({ onParamsChange: fetchUsers })

  return (
    <Page
      permissions={Permission.listUser}
      pageTitle={{
        title: 'Clients List',
        level: 4,
        badge: { count: numberFormat(query.pagination?.total ?? 0) },
      }}
    >
      <TableFilters
        initialValues={{
          name: params.search.name,
        }}
        onValuesChange={handleFiltersChange}
        left={[
          {
            name: 'name',
            type: 'search',
            input: <Input placeholder="Search client" allowClear />,
          },
        ]}
        right={[
          {
            type: 'button',
            input: <User.ExportUsers />,
          },
        ]}
      />
      <SBTable
        columns={columns}
        dataSource={users}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
        scroll={{ x: 'max-content' }}
      />
    </Page>
  )
}

export default UsersPage
